import React, { useState } from 'react';
import { HiOutlineMail, HiOutlineGlobeAlt, HiOutlineChatAlt2, HiOutlineLocationMarker } from 'react-icons/hi';
import './Contact.css';

const contactMethods = [
  {
    icon: <HiOutlineMail />,
    title: 'Email Us',
    desc: 'For general inquiries and support.',
    value: 'info@aiscaler.app',
    link: 'mailto:info@aiscaler.app',
  },
  {
    icon: <HiOutlineChatAlt2 />,
    title: 'Sales',
    desc: 'For business and enterprise plans.',
    value: 'paul@aiscaler.app',
    link: 'mailto:paul@aiscaler.app',
  },
  {
    icon: <HiOutlineGlobeAlt />,
    title: 'Website',
    desc: 'Visit us online.',
    value: 'aiscaler.app',
    link: 'https://aiscaler.app',
  },
  {
    icon: <HiOutlineLocationMarker />,
    title: 'Office',
    desc: 'Our registered address.',
    value: '89 City Walls Rd, Clifford Chambers, Warwickshire CV37 2LX, GB',
    link: null,
  },
];

export default function Contact() {
  const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <div className="contact-page">
      <section className="page-hero">
        <div className="container">
          <span className="section-label">Contact</span>
          <h1 className="section-title">Get in Touch</h1>
          <p className="section-subtitle">
            Have a question, feedback, or want to discuss enterprise plans? We'd love to hear from you.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="contact-methods">
            {contactMethods.map(({ icon, title, desc, value, link }) => {
              const Tag = link ? 'a' : 'div';
              const props = link ? { href: link } : {};
              return (
                <Tag key={title} {...props} className="card contact-method">
                  <div className="contact-method__icon">{icon}</div>
                  <h3 className="contact-method__title">{title}</h3>
                  <p className="contact-method__desc">{desc}</p>
                  <span className="contact-method__value">{value}</span>
                </Tag>
              );
            })}
          </div>
        </div>
      </section>

      <section className="section contact-form-section">
        <div className="container">
          <div className="contact-form-wrap">
            <div className="contact-form-info">
              <span className="section-label">Send a Message</span>
              <h2 className="section-title" style={{ fontSize: 32 }}>We'll Get Back to You</h2>
              <p className="section-subtitle">
                Fill out the form and our team will respond within 24 hours during business days.
              </p>
              <div className="contact-form-info__details">
                <p><strong>Support:</strong> info@aiscaler.app</p>
                <p><strong>CEO:</strong> paul@aiscaler.app</p>
                <p><strong>CTO:</strong> george@aiscaler.app</p>
              </div>
            </div>
            <div className="contact-form-box">
              {submitted ? (
                <div className="contact-form-success">
                  <span className="contact-form-success__icon">✓</span>
                  <h3>Message Sent!</h3>
                  <p>Thank you for reaching out. We'll get back to you soon.</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="contact-form">
                  <div className="contact-form__row">
                    <div className="contact-form__field">
                      <label>Name</label>
                      <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Your name" required />
                    </div>
                    <div className="contact-form__field">
                      <label>Email</label>
                      <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="you@example.com" required />
                    </div>
                  </div>
                  <div className="contact-form__field">
                    <label>Subject</label>
                    <input type="text" name="subject" value={formData.subject} onChange={handleChange} placeholder="How can we help?" required />
                  </div>
                  <div className="contact-form__field">
                    <label>Message</label>
                    <textarea name="message" rows={5} value={formData.message} onChange={handleChange} placeholder="Tell us more..." required />
                  </div>
                  <button type="submit" className="btn btn-primary contact-form__submit">Send Message</button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
